import { render, staticRenderFns } from "./home-component.vue?vue&type=template&id=5488a83a"
import script from "./home-component.vue?vue&type=script&lang=ts"
export * from "./home-component.vue?vue&type=script&lang=ts"
import style0 from "./home-component.vue?vue&type=style&index=0&id=5488a83a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports